export const GET_LIST_LESSONS = '/lesson/list';
export const GET_ALL_LESSONS = '/lesson/getAll';
export const GET_LESSON_INFO = '/lesson/getById';
export const CREATE_LESSON = '/lesson/create';
export const UPDATE_LESSON = '/lesson/update';
export const DELETE_LESSON = '/lesson/delete';
